import { CheckCircle2 } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import AuthLayout from '@/components/AuthLayout';

const VERIFICATION_EMAIL_STORAGE_KEY = 'signup.verificationEmail';

export default function SignupSuccess() {
  const location = useLocation();
  const fromState = (location.state as { verificationEmail?: boolean } | null)
    ?.verificationEmail;

  // Persist to sessionStorage so a page refresh (which drops router state)
  // still shows the right copy instead of silently falling back.
  useEffect(() => {
    if (fromState !== undefined) {
      sessionStorage.setItem(
        VERIFICATION_EMAIL_STORAGE_KEY,
        String(Boolean(fromState))
      );
    }
  }, [fromState]);

  const verificationEmail =
    fromState !== undefined
      ? Boolean(fromState)
      : sessionStorage.getItem(VERIFICATION_EMAIL_STORAGE_KEY) === 'true';

  return (
    <AuthLayout subtitle="Register">
      <div className="text-center">
        <CheckCircle2 className="mx-auto h-10 w-10 text-primary" />
        <h1 className="mt-4 text-2xl font-bold">
          {verificationEmail ? 'Check your email' : 'Request received'}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          {verificationEmail
            ? 'We sent you a link to verify your email and set your password. Follow it to finish signing up, then return here to sign in.'
            : 'If your request is eligible, an administrator will review it and email you with the decision. No further action is required from you right now.'}
        </p>
        <Link
          to="/login"
          className="mt-6 inline-flex font-medium text-primary underline-offset-4 hover:underline"
        >
          Back to sign in
        </Link>
      </div>
    </AuthLayout>
  );
}
